'use strict';

const baseDetails = require('richemont/product/detail');

baseDetails.swatchSlick = function () {
    $('.swatch-slick').each(function () {
        const $this = $(this);
        const swathLength = $this.find('.swatch-item').length;
        const windowWidth = $(window).width();
        const $thisparent = $this.closest('.attribute-swatch-list');
        if (!$this.hasClass('slick-initialized')) {
            if (windowWidth < window.app.grid.lg || (windowWidth >= window.app.grid.lg && swathLength > 5))
                $this.slick({
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: false,
                    speed: 500,
                    touchThreshold: 100,
                    dots: false,
                    arrows: true,
                    nextArrow: $thisparent.find('.slick-next'),
                    prevArrow: $thisparent.find('.slick-prev'),
                    responsive: [
                        {
                            breakpoint: window.app.grid.lg,
                            settings: {
                                variableWidth: true,
                                slidesToShow: 5,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: window.app.grid.md,
                            settings: {
                                variableWidth: true,
                                slidesToShow: 2.5,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
        }
    });
};

baseDetails.relatedProductsSwatchSlick = function () {
    $('.related-products-swatch-slick').each(function () {
        const $this = $(this);
        const windowWidth = window.app.window.width();
        const productsList = $('.related-products-swatch-slick .swatch-item');
        const productsCount = productsList.length;
        const productsWidth = productsList.width() * productsCount + 80;
        if (!$this.hasClass('slick-initialized')) {
            if (windowWidth < window.app.grid.md && productsWidth > windowWidth) {
                $this.slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    speed: 500,
                    touchThreshold: 100,
                    dots: false,
                    arrows: false,
                });
            }
        }
    });
};

baseDetails.sizeChartBackArrowClick = function () {
    $(document).on('click', '.size-chart-overlay .back-arrow', function () {
        $('.size-chart-overlay').removeClass('active slider-animate');
        $('.pdp-right-wrapper .slider-container').removeClass('kids-size-chart-overlay');
    });
};

baseDetails.updateProductBadges = function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        const $productContainer = response.container;
        const data = response.data;
        const product = data.product;
        const $addToWishlistForm = $('.add-to-wishlist-form.left-section-wishlist');

        const $stockBadges = $productContainer.find('.stock-badges-wrapper');
        var badges = [];
        $stockBadges.empty();
        if (product.badgeOnlineSoldOut || product.badgeAvailableSoon) {
            badges.push($stockBadges.attr('data-label-oos'));
        } else if (product.badgePreOrder) {
            badges.push($stockBadges.attr('data-label-preorder'));
        }
        badges.forEach(function (badgeText) {
            var badge = $('<span>', {
                class: 'badge',
                text: badgeText,
            });
            $stockBadges.append(badge);
        });

        const $textBadges = $productContainer.find('.text-badges-wrapper');
        var otherBadges = [];
        $textBadges.empty();
        if (product.textTag) {
            otherBadges.push(product.textTag);
        }
        if (product.boutiqueExclusive) {
            otherBadges.push($textBadges.attr('data-label-boutique'));
        }
        otherBadges.forEach(function (badgeText) {
            var badge = $('<span>', {
                class: 'badge',
                text: badgeText,
            });
            $textBadges.append(badge);
        });
        if (!product.available) {
            $addToWishlistForm.addClass('d-none');
        } else {
            $addToWishlistForm.removeClass('d-none');
        }
    });
};

baseDetails.removeProductFromWishlist = function () {
    $('body').on('click', '.successful-add-to-wishlist-modal .close', function (e) {
        e.preventDefault();
        $('.successful-add-to-wishlist-modal').modal('hide');
        $('body').css('padding-right', 0);
    });
    $('.remove-from-wishlist-modal, .successful-add-to-wishlist-modal').on('click', function (e) {
        if ($(e.target).hasClass('modal')) {
            $('body').css('padding-right', 0);
        }
    });
};

baseDetails.wishlistCancelBtnClick = function () {
    let $removeFromWishlistModal = $('.remove-from-wishlist-modal');
    $('body').on('click', '.remove-from-wishlist-modal .cancel-btn', function () {
        $(this).closest('.product-wrapper').find('.wishlist-wrapper').addClass('added-to-wishlist');
        $removeFromWishlistModal.modal('hide');
        $('body').css('padding-right', 0);
    });

    $('body').on('click', '.remove-from-wishlist-modal .close', function (e) {
        e.preventDefault();
        $removeFromWishlistModal.modal('hide');
        $('body').css('padding-right', 0);
    });
};

module.exports = baseDetails;
